"use client";
import AES from "./AES";
import { getHost } from "@/utils/fetch";
import Cookies from "js-cookie";
import md5 from "js-md5";

//获取window.localStorage里的参数值
// param@a{String} 键，格式：cityId
export function getLocal(a) {
  if (typeof window === "undefined") return "";
  return localStorage[a];
}

export const getUrlParams = (propName) => {
  const str =
    window.location.search.substring(1) || window.location.href.split("?")[1];
  let obj = {};
  if (str) {
    obj = str.split("&").reduce(
      (prev, curr) => ({
        ...prev,
        [curr.split("=")[0]]: curr.split("=")[1]
          ? decodeURIComponent(curr.split("=")[1])
          : "",
      }),
      {}
    );
  }
  return propName ? obj[propName] : obj;
};

// 组织headers里的公共参数， 默认会放入 经纬度+城市
// param@params{Object} 需要补充的参数，格式：{storeId:32323}
export function getPublicParams(params) {
  let obj = { ...params };
  if (typeof window !== "undefined") {
    const lng = localStorage.getItem("lng");
    const lat = localStorage.getItem("lat");
    const cityId = localStorage.getItem("cityId");

    if (lng && lat) {
      obj = {
        ...obj,
        "x-longitude": AES.encrypt(lng),
        "x-latitude": AES.encrypt(lat),
        "x-locationCityId": cityId,
        cityId: cityId,
      };

      return obj;
    }
    return obj;
  }
  return obj;
}

// 获取DOM元素距离左上角的 页面距离 top和left
// param@el{HTMLElement} 要计算的DOM元素A，格式：document.getElementById('aa')
// param@pNode{HTMLElement} 父级DOM元素B，默认为空，如果元素B有值则会计算元素A到元素B的距离，格式：document.getElementById('bb')
export function getOffset(el, pNode) {
  let ele = el;
  let eleP = ele.offsetParent;
  let dirTop = 0;
  let dirLeft = 0;

  // console.log(ele.offset,ele.offsetTop,(pNode && eleP && pNode.contains(eleP)),pNode, eleP,pNode.contains(eleP));
  while ((pNode && eleP && pNode.contains(eleP)) || (!pNode && eleP)) {
    dirTop += ele.offsetTop;
    dirLeft += ele.offsetLeft;

    ele = eleP;
    eleP = ele.offsetParent;
  }

  return {
    top: dirTop,
    left: dirLeft,
    width: el.clientWidth,
    height: el.clientHeight,
  };
}

/**
 * 界面变速或匀速滚动，只关注前四个参数，后面的参数为减少变量定义而存在
 * @param {HTMLDivElement} scrollContainer 要触发滚动的容器
 * @param {Function} callback 滚动完毕后的回调函数
 * @param {Number} initTop 当前浏览器的滚动的高度，可使用 document.documentElement.scrollTop 获取
 * @param {Number} offset 需要移动的距离
 * @param {Number} down 是否是向下滚动是则为 1，向上为 -1
 * @param {Bool} a 是否变速运动
 * @param {Number} moved 已经移动了的总距离
 * @param {Number} i 每次移动的距离，通过计算而来
 * @param {Number} m 实际移动的距离，带有方向，正数为向下，负数为向上，为减少变量定义而存在，无需关注
 */
export function anim(
  scrollContainer,
  callback,
  initTop,
  offset,
  down,
  a = false,
  moved = 0,
  i = 1,
  m = 0
) {
  if (offset === 0) {
    if (callback) callback();
    return false;
  }

  setTimeout(() => {
    i = a ? (moved < offset - 128 ? i * 1.02 : i / 1.6) : i;
    // i = Math.max(i, 32);  // 最小单步距离是32
    i = i < 1 ? 1 : i;
    // i = i > 32 ? 32 : i;

    m = i * down;
    if (moved + i > offset) m = (offset - moved) * down;
    moved += i;
    scrollContainer.scrollTop = initTop + m;
    // console.log(moved, offset, m, scrollContainer.scrollTop);

    if (moved < offset) {
      anim(scrollContainer, callback, initTop + m, offset, down, a, moved, i);
    } else if (callback) callback();
  }, 1);
}

export const defaultImage =
  "data:image/png;base64,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";

// 将url里如果有item里的参数， 则被覆盖
export const replaceUrl = (url, item) => {
  let urlpre = url;
  let obj = { ...item };
  if (url.indexOf("?") > -1) {
    let obj2 = url
      .split("?")[1]
      .split("&")
      .reduce((rev, f) => {
        const brr = f.split("=");
        return {
          ...rev,
          [brr[0]]: brr[1],
        };
      }, {});

    obj = { ...obj2, ...item };
    urlpre = url.split("?")[0];
  }

  const crr = Object.keys(obj).map((item2) => {
    return `${item2}=${obj[item2]}`;
  });
  const urlRes = `${urlpre}?${crr.join("&")}`;

  return urlRes;
};

// 从现有的参数里根据key提取后， 覆盖之前的参数，并剔除指定的key
// param@params{Object} 现在的参数
// param@includeKey{String} 需要提取的key 格式：a,b
// param@oldParams{Object} 之前的参数
// param@excludeKey{String} 需要剔除的key 格式：a,b
export const replaceParams = (params, includeKey, oldParams, excludeKey) => {
  const arr = includeKey?.split(",") || [];
  let params2 = {};

  arr.map((item) => {
    if (params[item]) {
      params2[item] = params[item];
    }
  });

  Object.keys(params).map((item2) => {
    // 将params里所有的key都从oldParams里面删掉
    delete oldParams[item2];
  });

  params2 = {
    ...oldParams,
    ...params2,
  };

  // console.log(arr,params,params2)

  const err = excludeKey?.split(",") || [];
  err.map((item) => {
    delete params2[item];
  });

  const crr = Object.keys(params2).map((item2) => {
    return `${item2}=${params2[item2]}`;
  });

  const urlRes = `?${crr.join("&")}`;

  return urlRes;
};

// param@params{Object} 现在的参数  回退的时候，此项是null
// param@extParams{Object} 外加固定参数 比如 {checkedCity:1}
// param@oldParams{Object} 之前的参数
// param@excludeKey{String} 需要剔除的key 格式：a,b
export const replaceParamsStore = (
  params,
  extParams,
  oldParams,
  excludeKey
) => {
  let params2 = {
    ...oldParams,
    ...extParams,
  };
  if (params) {
    params2 = {
      ...params2,
      scityName: params.cityName,
      scityId: params.cityId,
      scityCode: params.cityCode,
    };
  }
  // console.log(arr,params,params2)

  const err = excludeKey?.split(",") || [];
  err.map((item) => {
    delete params2[item];
  });

  const crr = Object.keys(params2).map((item2) => {
    return `${item2}=${params2[item2]}`;
  });

  const urlRes = `?${crr.join("&")}`;

  return urlRes;
};

// 百度地图转腾讯地图
export function convertBaiduToTencent(bd_lon, bd_lat) {
  const bdLngLat = [bd_lon, bd_lat];
  var x_pi = (Math.PI * 3000.0) / 180.0;
  var z = bdLngLat[0] - 0.0065;
  var ee = 0.00669342162296594323;
  var a = 6378245.0;
  var eee = 0.00669342162296594323;
  var dlng = transformLon(z, ee);
  var radlat = (bdLngLat[1] / 180.0) * Math.PI;
  var magic = Math.sin(radlat);
  magic = 1 - eee * magic * magic;
  var sqrtmagic = Math.sqrt(magic);
  dlng =
    (dlng * 180.0) /
    (((a * (1 - eee)) / (magic * sqrtmagic)) * Math.cos(radlat) * Math.PI);
  var mglat = bdLngLat[1];
  var mgln = z * 1 + dlng;
  return [mgln, mglat];
}

function transformLon(lon, PI) {
  if (lon < 0.008293 || lon > 0.008293) {
    return lon;
  } else {
    return 0.008293;
  }
}

// 百度经纬度转高德
let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
export function convertBaiduToGaoDe(bd_lon, bd_lat) {
  let x = Number(bd_lon - 0.0065);
  let y = Number(bd_lat - 0.006);
  let z = Number(Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi));
  let theta = Number(Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi));
  bd_lon = Number(z * Math.cos(theta));
  bd_lat = Number(z * Math.sin(theta));
  return [bd_lon, bd_lat];
}

// 定位
export async function dingwei() {
  return new Promise((resolve, reject) => {
    getDingWei(resolve);
  });
}

function getDingWei(resolve) {
  if (typeof BMapGL === "undefined") {
    setTimeout(() => {
      getDingWei(resolve);
    }, 200);
    return;
  }

  let geolocation = new BMapGL.Geolocation();

  geolocation.getCurrentPosition(
    async function (r) {
      resolve(r?.point);
    },
    { enableHighAccuracy: true }
  );
}

// 设备类型  设备平台
export function shebeiType() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端

  if (isiOS) {
    return "ios";
  }

  if (isAndroid) {
    return "android";
  }

  return "pc";
}

export function importJs(url, tbody, callback) {
  var script = document.createElement("script");
  script.src = url;

  if (tbody === "body") {
    document.getElementsByTagName("body")[0].appendChild(script);
  } else {
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  if (callback) {
    script.onload = function () {
      callback();
    };
  }
}

export const isMobile = () => {
  let ua = "";
  if (typeof window !== "undefined") {
    ua = navigator.userAgent.toLowerCase();
  } else {
    const { headers } = require("next/headers");
    ua = headers().get("user-agent");
  }
  return ua.match(/(android|iphone|ipad)/);
};

export const getLeadsSourceId = () => (isMobile() ? 100244 : 100245);

export const getIMLink = ({ ucarId, unifiedNumber }) => {
  const host = getHost();
  return `${
    host.h5
  }/IMChat/M/index.html?t=1701078098527&ucarId=${ucarId}&unifiedNumber=${unifiedNumber}&leadsSourceId=${getLeadsSourceId()}`;
};

export const getUrlCookie = (urlParams2) => {
  const urr = {};
  if (urlParams2) {
    const arr = urlParams2.split("&");

    arr.map((item) => {
      const brr = item.split("=");
      if (brr[0] === "city") {
        urr.city = brr[1];
      } else if (brr[0] === "storeId") {
        urr.storeId = brr[1];
      }
    });
  }

  if (!urr.city) {
    const cc = Cookies.get("city");
    if (cc) {
      const citySpell22 = JSON.parse(cc).citySpell;
      urr.city = citySpell22;
    }
  }
  if (!urr.storeId) {
    const cc = Cookies.get("storeId");
    if (cc) {
      urr.storeId = cc;
    }
  }
  const brr = [];
  Object.keys(urr).map((item) => {
    brr.push(`${item}=${urr[item]}`);
  });
  const urlParams = brr.length > 0 ? `${brr.join("&")}` : "";

  return urlParams;
};

export function generateMixed(n) {
  const chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  let res = "";
  for (let i = 0; i < n; i += 1) {
    const id = Math.floor(Math.random() * 36);
    res += chars[id];
  }
  return res;
}

export function getCodeParams(obj = { expires: "", nonce: "" }) {
  const pam = {
    clientId: "vN4MaMD6",
    expires: obj.expires || new Date().getTime() + 24 * 60 * 60 * 1000,
    nonce: obj.nonce || generateMixed(10),
    sign: "",
  };
  const str = `iEjSZx6NclientId=vN4MaMD6&expires=${pam.expires}&nonce=${
    obj.nonceToken || pam.nonce
  }`;

  pam.sign = md5(md5(str)).substr(0, 12);
  const rs = Object.keys(pam)
    .map((item) => {
      return `${item}=${pam[item]}`;
    })
    .join("&");

  return {
    str: rs,
    obj: pam,
  };
}
